<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { ADMIN_INVOICES } from '@/store/types';
import invoicesApi from '@/services/apis/admin/invoices.api';

export default {
  props: {
    page: {
      type: Number,
      default: 1,
    },
    per_page: {
      type: Number,
      default: 10,
    },
    keyword: {
      type: String,
      default: '',
    },
    employer_id: {
      type: String,
      default: null,
    },
    start_date: {
      type: String,
      default: null,
    },
    end_date: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const store = useStore();
    const query = ref(null);
    query.value = invoicesApi.useAdminInvoicesQuery({
      page: props.page,
      per_page: props.per_page,
      keyword: props.keyword,
      employer_id: props.employer_id,
      start_date: props.start_date,
      end_date: props.end_date,
    });
    if (query.value) {
      store.commit(ADMIN_INVOICES.SET_INVOICES_QUERY, query);
    }
    return { query };
  },
};
</script>
